import store from "@/store/index";

export default (to, from, next) => {
  if (store.getters["auth/loggedIn"]) {
    next();
  } else {
    next({ name: "login" });
  }
};
